import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getProductById } from "../../services/ProductService";
import style from "./index.module.css";

export default function Readmore() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState(""); 

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const data = await getProductById(id);
        setProduct(data);
        if (data.photos?.length > 0) {
          setMainImage(data.photos[0].photoName);
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return <p>Loading product details...</p>;
  }

  if (!product) {
    return <p>Product not found.</p>;
  }

  return (
    <div className={style.productDetails}>
      <h1>{product.productName}</h1>
      <img src={mainImage} alt={product.productName} className={style.mainImage} />
      
      <div className={style.imageGallery}>
        {product.photos?.map((image, index) => (
          <img 
            key={index} 
            src={image.photoName} 
            alt="Product" 
            onClick={() => setMainImage(image.photoName)} 
          />
        ))}
      </div>

      <p>Price: ${product.productPrice}</p>
      <p>Description: {product.productDescription}</p>
    </div>
  );
}
